import React from 'react';
import { Map, AlertTriangle, ListChecks, Search, CalendarCheck } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const TOOLS = [{
  icon: Map,
  title: 'Mapa Maestro de Maniobras',
  desc: 'Consulta pruebas rápidamente.',
  tone: 'text-clinic-light bg-clinic/12 border-clinic/30'
}, {
  icon: AlertTriangle,
  title: 'Guía de Banderas Rojas',
  desc: 'Identifica señales de alerta.',
  tone: 'text-copper bg-copper/12 border-copper/30'
}, {
  icon: ListChecks,
  title: 'Listas Clínicas de Bolsillo',
  desc: 'Estructura cada evaluación.',
  tone: 'text-steel bg-steel/15 border-steel/35'
}, {
  icon: Search,
  title: 'Diagnóstico Diferencial Visual',
  desc: 'Compara presentaciones clínicas.',
  tone: 'text-sage bg-sage/15 border-sage/35'
}, {
  icon: CalendarCheck,
  title: 'Plan Clínico de 21 Días',
  desc: 'Integra el razonamiento a tu práctica.',
  tone: 'text-gold bg-gold/12 border-gold/30'
}];
export function BonusStack() {
  return <AnimatedSection className="relative bg-navy-900 py-10 sm:py-14 overflow-hidden" data-id="element-33" data-mp="3scwa8y6u9lee">
      <div aria-hidden className="absolute -bottom-24 -left-16 w-[320px] h-[320px] rounded-full bg-petrol/20 blur-[100px] pointer-events-none" data-id="element-34" data-mp="3ncidicaotxvo" />
      <div aria-hidden className="absolute -top-20 right-0 w-[260px] h-[260px] rounded-full bg-gold/[0.06] blur-[100px] pointer-events-none" data-id="element-35" data-mp="3dkvv9vzxmyjf" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36" data-mp="34l8v1dixvyry">
        <span className="inline-block text-[9px] sm:text-[10.5px] font-bold uppercase tracking-[0.14em] text-clinic-light bg-clinic/10 border border-clinic/35 rounded-full px-2.5 py-1 mb-3" data-id="element-37" data-mp="34nbrafaoqo54">
          Incluidas sin costo extra
        </span>
        <h2 className="font-heading text-white tracking-tight text-[1.3rem] sm:text-[2rem] leading-[1.16] max-w-xl mb-5 sm:mb-7" data-id="element-38" data-mp="xvaxpb7yobi0">
          <span className="font-extrabold" data-id="element-39" data-mp="swzon2phq50u">5 herramientas</span>{' '}
          <span className="font-editorial italic text-gold font-medium" data-id="element-40" data-mp="2nbd8dwq6vlnd">
            para tener a mano cuando las necesites.
          </span>
        </h2>

        {/* 2-up grid on mobile, last one spans · 5-up on desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 sm:gap-3" data-id="element-41" data-mp="2df1tcyz7shp8">
          {TOOLS.map((tool, idx) => <article key={tool.title} className={`bg-navy-800/80 border border-white/10 rounded-xl p-3 sm:p-3.5 flex flex-col ${idx === TOOLS.length - 1 ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-42" data-mp="2idbtlnzsq8hp" data-mpi={idx}>
              <span className={`w-8 h-8 rounded-lg border flex items-center justify-center mb-2 ${tool.tone}`} data-id="element-43" data-mp="2w48hx2mow3iy">
                <tool.icon size={15} strokeWidth={2} data-id="element-44" data-mp="312a1doo124uy" />
              </span>
              <h3 className="font-heading font-bold text-white text-[12.5px] sm:text-[14px] leading-tight mb-0.5" data-id="element-45" data-mp="1kojuyb9fr4i5">
                {tool.title}
              </h3>
              <p className="text-[11px] sm:text-[12.5px] text-gray-400 leading-snug" data-id="element-46" data-mp="1pm1td7ptu1bw">
                {tool.desc}
              </p>
            </article>)}
        </div>
      </div>
    </AnimatedSection>;
}